import { DraftEmailAttachment } from "client/Api/Email/respondToEmail";
import { newGuid } from "client_legacy/ndaw/guid";

export enum AttachmentKind {
	Normal = 0,
	Inline = 1
}

export enum AttachmentStatus {
	Uploading = 0,
	Uploaded = 1
}

type CommonAttachmentItem = {
	uid: string;
	name: string;
	size: number;
};

export type UploadingAttachment = CommonAttachmentItem & {
	status: AttachmentStatus.Uploading;
	kind: AttachmentKind;
};

export type UploadedNormalAttachment = CommonAttachmentItem & {
	status: AttachmentStatus.Uploaded;
	kind: AttachmentKind.Normal;
	exchangeId: string;
};

export type UploadedInlineAttachment = CommonAttachmentItem & {
	status: AttachmentStatus.Uploaded;
	kind: AttachmentKind.Inline;
	exchangeId: string;
	contentId: string;
};

export type AttachmentItem =
	| UploadingAttachment
	| UploadedNormalAttachment
	| UploadedInlineAttachment;

export type EnqueueAttachmentUpload = <T>(operation: () => Promise<T>) => Promise<T>;

export function isUploadedInlineAttachment(attachment: AttachmentItem): attachment is UploadedInlineAttachment {
	return attachment.status === AttachmentStatus.Uploaded
		&& attachment.kind === AttachmentKind.Inline;
}

export function convertToAttachmentItem(
	draftAttachment: DraftEmailAttachment,
	uid: string = newGuid()
): AttachmentItem {
	if (draftAttachment.isInline) {
		return {
			status: AttachmentStatus.Uploaded,
			kind: AttachmentKind.Inline,
			name: draftAttachment.name,
			size: draftAttachment.size,
			exchangeId: draftAttachment.id,
			contentId: draftAttachment.contentId,
			uid
		};
	}

		return {
			status: AttachmentStatus.Uploaded,
			kind: AttachmentKind.Normal,
			exchangeId: draftAttachment.id,
			name: draftAttachment.name,
			size: draftAttachment.size,
			uid
		};
	};